<app-loading *ngIf="authService.loading"></app-loading>
<app-modal-login
  #modalLogin
  (onAcceder)="iniciarSesion($event)"></app-modal-login>

<app-topbar (onShowModalLogin)="modalLogin.show()"></app-topbar>

<app-navbar (onShowModalLogin)="modalLogin.show()"></app-navbar>

<router-outlet></router-outlet>
